

import {dealStagesData} from "../../Enum.js"

const ColumnData = [
  {
    id: dealStagesData["Site Visit"],
    title: "Site Visit",
    bgColor:'#B9DAD0',
    overallSquareFeet:'2,800 Sq feet',

    tasks: [
      
    ],
  },
  {
    id: dealStagesData["After Site Visit Follow Up"],
    title: "After Site Visit Follow Up",
    bgColor:'#94C8B7',
    overallSquareFeet:'2,800 Sq feet',

    tasks: [
      
    ],
  },
  {
    id: dealStagesData["Sitting"],
    title: "Sitting",
    bgColor:'#70B89E',
    overallSquareFeet:'2,800 Sq feet',

    tasks: [
      
    ],
  },
  {
    id: dealStagesData["After Sitting Follow Up"],
    title: "After Sitting Follow Up",
    bgColor:'#4BA785',
    overallSquareFeet:'2,800 Sq feet',

    tasks: [
      
    ],
  },
  {
    id: dealStagesData["Plot Booked"],
    title: "Plot Booked",
    bgColor:'#03B070',
    overallSquareFeet:'2,800 Sq feet',

    tasks: [
     
    ],
  },
  {
    id: dealStagesData["Advance Amount Update"],
    title: "Advance Amount Update",
    bgColor:'#03B070',
    overallSquareFeet:'2,800 Sq feet',

    tasks: [
      
    ],
  },

  {
    id: dealStagesData["Registration InProgress"],
    title: "Registration InProgress",
    bgColor:'#03B070',
    overallSquareFeet:'2,800 Sq feet',

    tasks: [
      
    ],
  },
  {
    id: dealStagesData["Fully Registered"],
    title: "Fully Registered",
    bgColor:'#07BA77',
    overallSquareFeet:'2,800 Sq feet',

    tasks: [
     
    ],
  },
  {
    id: dealStagesData["Deal Lost Before Booking"],
    title: "Deal Lost Before Booking",
    bgColor:'#E0A0A0',
    overallSquareFeet:'2,800 Sq feet',

    tasks: [
      
    ],
  },
  {
    id: dealStagesData["Deal Lost After Booking"],
    title: "Deal Lost After Booking",
    bgColor:'#E0A0A0',
    overallSquareFeet:'2,800 Sq feet',

    tasks: [
      
    ],
  },
];

export default ColumnData;
